export const APP_NAME = 'Megnus';
export const PERSIST_STORE_NAME = 'admin';
export const REDIRECT_URL_KEY = 'redirectUrl';
export const FCM_TOKEN = 'FCM_TOKEN';
